import { render, staticRenderFns } from "./AggregatorDetails.vue?vue&type=template&id=e2c6d1e4&"
import script from "./AggregatorDetails.vue?vue&type=script&lang=js&"
export * from "./AggregatorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports